<template>
  <div :class="inlinerows == 'true' ? margins + ' row' : margins">
    <label v-if="label" for="exampleFormControlInput1" :class="inlinerows == 'true' ? 'col-sm-2 col-form-label' : 'form-label'">{{ label }}</label>
    <div :class="inlinerows == 'true' ? 'col-sm-10' : label ? '' : 'col-md-12'">
      <div class="input-group">
        <b-form-input v-model="selectedValue" :placeholder="placeholder" :class="classes" :type="type" :readOnly="btn_readOnly" :value="selectedValue" @input="onInput"></b-form-input>
        <div class="input-group-append">
          <my-button :fa="btn_fa" :label="btn_label" :variant="btn_variant" :classes="btn_classes" :height="btn_height" :width="btn_width" :inputGroup="btn_inputGroup" @onClick="clickHandler"></my-button>
        </div>
      </div>
      <small class="input-error" v-if="error">{{ error }}</small>
    </div>
  </div>
</template>

<script>
import "../../assets/scss/form-group.scss";
import "../../assets/scss/text-input-group.scss";
import MyButton from "../atoms/Button.vue";

export default {
  name: "text-input-group",
  components: {
    MyButton,
  },
  data() {
    return {
      selectedValue: this.default_value,
    };
  },
  created() {},
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: "text",
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      required: false,
    },
    mandatory: {
      default: false,
    },
    inlinerows: {
      default: false,
    },
    classes: {
      type: String,
      default: "",
    },
    btn_label: {
      type: String,
      default: "",
    },
    btn_variant: {
      type: String,
      default: "",
    },
    btn_fa: {
      type: String,
      default: "",
    },
    btn_size: {
      type: String,
      validator: function(value) {
        return ["small", "medium", "large"].indexOf(value) !== -1;
      },
    },
    btn_classes: {
      type: String,
      default: "",
    },
    btn_width: {
      type: String,
      default: "",
    },
    btn_minwidth: {
      type: String,
      default: "",
    },
    btn_height: {
      type: String,
      default: "",
    },
    default_value: {
      type: String,
      default: "",
    },
    btn_readOnly: {
      default: false,
    },
    btn_inputGroup: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    margins: {
      default: "mb-3",
    },
  },

  methods: {
    clickHandler() {
      this.$emit("onClick");
    },
    onInput() {
      this.$emit("input", this.selectedValue);
    },
  },
};
</script>
